import Input from '../../../ui/input';
import DateInput from '../../../ui/date-input';
import Text from '../../../ui/text';
import { useFormContext } from 'react-hook-form';
import MedicalCardExampleSrc from '../../../../assets/images/medical-card-example.png';

function MedicalHealthInformation() {
  const { 
    register,
    control,
    formState: { errors },
  } = useFormContext();
  return (
    <section className="w-full">
      <h2 className="text-2xl font-semibold text-secondary">
        <Text>Medicare Health Information</Text>
      </h2>
      <p>
        <Text>Please take out your red, white, and blue Medicare card to complete this section. Fill out this information as it appears on your Medicare card. You must have Medicare Part A and Part B to join a Medicare Advantage plan.</Text>
      </p>
      <div className="grid grid-cols-12 gap-5 mt-5">
        <div className='col-span-12 sm:col-span-4 flex flex-col justify-start items-start'>
          <Text type='label' htmlFor='medicareNumber'>Medicare Number *</Text>
          <Input
            {...register('medicareNumber')}
            size='sm'
            label={<Text>Medicare Number</Text>}
            placeholder="-"
            errorMessage={errors?.medicareNumber?.message || null}
            isInvalid={errors?.medicareNumber ? true : false}
          />
        </div>
        <div className='col-span-12 sm:col-span-4 flex flex-col justify-end items-start'>
          <Text type='label' htmlFor='partACoverageDate'>Date Coverage Starts - Hospital (Part A) *</Text>
          <DateInput 
            name='partACoverageDate'
            label={<Text>Date</Text>} 
            control={control} 
            errorMessage={errors?.partACoverageDate?.message || null}
            isInvalid={errors?.partACoverageDate ? true : false}
          />
        </div>
        <div className='col-span-12 sm:col-span-4 flex flex-col justify-end items-start'>
          <Text type='label' htmlFor='partBCoverageDate'>Date Coverage Starts - Medical (Part B) *</Text>
          <DateInput 
            name='partBCoverageDate'
            label={<Text>Date</Text>} 
            control={control} 
            errorMessage={errors?.partBCoverageDate?.message || null}
            isInvalid={errors?.partBCoverageDate ? true : false}
          />
        </div>
      </div>
      <div className='my-10 flex flex-row justify-center items-center'>
        <img src={MedicalCardExampleSrc} className='w-full max-w-sm' />
      </div>
    </section>
  );
}

export default MedicalHealthInformation;